export default __webpack_public_path__ + "static/media/before.5d1482fb.png";